import * as React from 'react';
import { ProductAttributeInterface } from '../../../../Interface/ProductAttribute';
import NumberInput from '../../NumberInput/NumberInput';
import { useProductList } from '../../../Context/ProductListContext';
import { getRequest } from '../../../Helper/ApiClient';
import clsx from 'clsx';

export default function QuantityInput({
  product_attribute,
  price,
  combined_price,
  className,
  skipStockCheck = false,
}: {
  product_attribute: ProductAttributeInterface;
  price: number;
  combined_price?: number;
  className?: string;
  skipStockCheck?: boolean;
}) {
  const stockRequest = getRequest(
    `/api/flavour/${product_attribute.id}/getStock`,
    undefined,
    {
      enabled: false,
    }
  );

  const { addFlavour, removeFlavour, flavoursToAdd } = useProductList();
  const [isInvalid, setIsInvalid] = React.useState<boolean>(false);
  const defaultQuantity = React.useMemo(() => {
    return flavoursToAdd.find((el) => el.flavourId === product_attribute.erp_id)
      ?.quantity;
  }, [isInvalid, flavoursToAdd.length]);

  React.useEffect(() => {
    if (defaultQuantity === undefined && isInvalid) {
      setIsInvalid(false);
    }
  }, [defaultQuantity, isInvalid]);

  const onChange = (value?: number) => {
    if (value == null) {
      removeFlavour(product_attribute.erp_id);
    }
    if (value && value > 0) {
      addFlavour({
        flavourId: product_attribute.erp_id,
        price: combined_price ?? price,
        quantity: value,
      });
    }
    setIsInvalid(false);
  };

  const onBlur = (value?: number) => {
    if (!value) {
      return;
    }

    if (skipStockCheck) {
      setIsInvalid(false);
      addFlavour({
        flavourId: product_attribute.erp_id,
        quantity: value,
        price: combined_price ?? price,
      });
      return;
    }

    stockRequest
      .refetch()
      .then((response) => {
        const data = response?.data;
        if (data < value) {
          setIsInvalid(true);
          addFlavour({
            flavourId: product_attribute.erp_id,
            quantity: data ?? 0,
            price: combined_price ?? price,
          });
        } else {
          setIsInvalid(false);
          addFlavour({
            flavourId: product_attribute.erp_id,
            quantity: value,
            price: combined_price ?? price,
          });
        }
      })
      .catch((error) => {
        console.error('Stock fetch failed:', error);
        setIsInvalid(true);
      });
  };

  return (
    <NumberInput
      className={clsx('w-100 h-100', className)}
      invalid={isInvalid}
      inputValue={defaultQuantity}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
}
